import type { ReactNode } from 'react';

import { PortalLocaleProvider } from '@/lib/i18n/PortalLocaleProvider';

import { PortalLanguageToggle } from './PortalLanguageToggle';

/**
 * Language support for Parent Portal pages that sit outside `PortalLayout`
 * (sign in, register, family link). A parent must be able to read these
 * before they have an account, so the switch floats at the top right.
 */
export function PortalPublicLocale({ children }: { children: ReactNode }) {
  return (
    <PortalLocaleProvider>
      {children}
      <div className="fixed right-3 top-3 z-50" data-testid="portal-public-language">
        <PortalLanguageToggle />
      </div>
    </PortalLocaleProvider>
  );
}
